import React, { useState, useEffect } from 'react';

const BaseYearModal = ({ closeModal }) => {
  const [baseYearType, setBaseYearType] = useState('rolling');
  const [fixedYear, setFixedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const savedType = localStorage.getItem('baseYearType');
    const savedYear = localStorage.getItem('fixedBaseYear');
    if (savedType) {
      setBaseYearType(savedType);
    }
    if (savedYear) {
      setFixedYear(Number(savedYear));
    }
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    localStorage.setItem('baseYearType', baseYearType);
    if (baseYearType === 'fixed') {
      localStorage.setItem('fixedBaseYear', fixedYear.toString());
    }
    closeModal();
  };

  const yearsOption = Array.from({ length: 30 }, (_, index) => new Date().getFullYear() - index);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-filter backdrop-blur-lg flex justify-center items-center px-4 py-8 z-50">
      <div
        className="bg-white dark:bg-gray-800 p-8 rounded-lg max-w-lg w-full space-y-6"
        style={{ maxHeight: '80vh', overflowY: 'auto' }}
      >
        <h2 className="text-2xl font-semibold mb-6 dark:text-white">
          Base Year Settings
        </h2>
        <form className="space-y-5" onSubmit={handleSave}>
          <div className="flex flex-col space-y-3">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Select Base Year Type
            </label>
            <div className="flex flex-col space-y-2">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="baseYearType"
                  value="rolling"
                  checked={baseYearType === 'rolling'}
                  onChange={() => setBaseYearType('rolling')}
                  className="form-radio text-blue-500 h-5 w-5 focus:ring-blue-500"
                />
                <span className="ml-3 text-gray-700 dark:text-gray-300">Rolling Base Year</span>
              </label>
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="baseYearType"
                  value="fixed"
                  checked={baseYearType === 'fixed'}
                  onChange={() => setBaseYearType('fixed')}
                  className="form-radio text-blue-500 h-5 w-5 focus:ring-blue-500"
                />
                <span className="ml-3 text-gray-700 dark:text-gray-300">Fixed Base Year</span>
              </label>
            </div>
          </div>

          {baseYearType === 'fixed' && (
            <div className="flex flex-col space-y-2">
              <label htmlFor="fixedYearSelect" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Select Year
              </label>
              <select
                id="fixedYearSelect"
                value={fixedYear}
                onChange={(e) => setFixedYear(Number(e.target.value))}
                className="px-4 py-2 border rounded-lg bg-white dark:bg-gray-600 text-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {yearsOption.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={closeModal}
              className="px-5 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition duration-200 ease-in-out"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition duration-200 ease-in-out"
            >
              Save Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BaseYearModal;
